<script>
import loading from "@/components/elements/AppLoading.vue";
import {ExchangeRateService} from "@/services/ExchangeRateService";
import _ from "lodash";
import Swal from "sweetalert2";

export default {
  name: "SettingsExchangeRatesCurrencies",
  components: {loading},
  data() {
    const startYear = 2011;
    const currentYear = new Date().getFullYear();

    return {
      months : [
        'January','February','March','April','May','June',
        'July','August','September','October','November','December',
      ],
      selectedMonth : new Date().getMonth() + 1,
      selectedYear : new Date().getFullYear(),
      years : Array.from({ length: currentYear - startYear + 1 }, (_, i) => startYear + i),

      loading : true,
      allList : [],
      list : [],

      searchParams: {
        search: "",
        page: 1,
        perPage: 40
      },

      pagination: {
        currentPage: 1,
        lastPage: 1,
      },

      form: {
        id: null,
        name: "",
        code: ""
      },

      originalForm: {
        id: null,
        name: "",
        code: ""
      },

      deletePassword: "",
      errors: {},
    }
  },
  computed: {
    isFormChanged() {
      return this.form.name.trim() !== "" &&
        this.form.code.trim() !== "" &&
        (this.form.name !== this.originalForm.name || this.form.code !== this.originalForm.code);
    },
    isCreateReady() {
      return this.form.name.trim() !== "" && this.form.code.trim() !== "";
    },
    isDeleteReady() {
      return this.deletePassword.trim().length > 0;
    },
    paginationPages() {
      const total = this.pagination.lastPage;
      const current = this.pagination.currentPage;
      const visible = 11;
      const pages = [];

      if (total <= visible) {
        for (let i = 1; i <= total; i++) {
          pages.push(i);
        }
      } else {
        let start = current - Math.floor(visible / 2);
        let end = current + Math.floor(visible / 2);

        if (start < 1) {
          start = 1;
          end = visible;
        }

        if (end > total) {
          end = total;
          start = total - visible + 1;
        }

        for (let i = start; i <= end; i++) {
          pages.push(i);
        }
      }

      return pages;
    }
  },

  methods: {
    async getExchangeRate() {
      this.loading = true;
      this.allList = await ExchangeRateService.getExchangeRatesCurrencies({
        month : this.selectedMonth,
        year : this.selectedYear,
      });
      this.applyFilters();
      this.loading = false;
    },

    applyFilters() {
      let filtered = this.allList;

      if (this.searchParams.search) {
        const term = this.searchParams.search.toLowerCase();
        filtered = filtered.filter(item =>
          item.currency_name.toLowerCase().includes(term) ||
          item.currency_code.toLowerCase().includes(term)
        );
      }

      const total = filtered.length;
      this.pagination.lastPage = Math.max(1, Math.ceil(total / this.searchParams.perPage));
      this.pagination.currentPage = Math.min(this.searchParams.page, this.pagination.lastPage);

      const start = (this.pagination.currentPage - 1) * this.searchParams.perPage;
      const end = start + this.searchParams.perPage;
      this.list = filtered.slice(start, end);
    },

    setPage(page) {
      if (page === "..." || page < 1 || page > this.pagination.lastPage) return;
      this.searchParams.page = page;
      this.applyFilters();
    },

    openCreateModal() {
      this.form = { id: null, name: "", code: "" };
      this.originalForm = { ...this.form };
      this.errors = {};
      $("#CreateCurrency").modal("show");
    },

    openUpdateModal(data) {
      this.form = { id: data.id, name: data.currency_name, code: data.currency_code };
      this.originalForm = { ...this.form };
      this.errors = {};
      $("#UpdateCurrency").modal("show");
    },

    openDeleteModal(data) {
      this.form = { id: data.id, name: data.currency_name, code: data.currency_code };
      this.errors = {};
      this.deletePassword = "";
      $("#DeleteCurrency").modal("show");
    },

    async createCurrency() {
      this.errors = {};
      const payload = {
        currency_name: this.form.name,
        currency_code: this.form.code
      };

      try {
        const result = await ExchangeRateService.createExchangeRateCurrency(payload);
        if (result) {
          $("#CreateCurrency").modal("hide");
          this.getExchangeRate();
          this.form = { id: null, name: "", code: "" };

          Swal.fire({
            icon: "success",
            title: "Currency created successfully!",
            confirmButtonColor: "#007bff",
            timer: 2000
          });
        }
      } catch (error) {
        if (error.response && error.response.status === 422) {
          this.errors = error.response.data.errors;
        } else {
          Swal.fire({
            icon: "error",
            title: "Something went wrong",
            text: error.message || "Please try again later",
            timer: 2000
          });
        }
      }
    },

    async updateCurrency() {
      this.errors = {};
      const payload = {
        currency_name: this.form.name,
        currency_code: this.form.code
      };

      try {
        const result = await ExchangeRateService.updateExchangeRateCurrency(this.form.id, payload);
        if (result) {
          $("#UpdateCurrency").modal("hide");
          this.getExchangeRate();
          this.form = { id: null, name: "", code: "" };

          Swal.fire({
            icon: "success",
            title: "Currency updated successfully!",
            confirmButtonColor: "#007bff",
            timer: 2000
          });
        }
      } catch (error) {
        if (error.response && error.response.status === 422) {
          this.errors = error.response.data.errors;
        } else {
          Swal.fire({
            icon: "error",
            title: "Something went wrong",
            text: error.message || "Please try again later",
            timer: 2000
          });
        }
      }
    },

    async deleteCurrency() {
      this.errors = {};
      try {
        const result = await ExchangeRateService.deleteExchangeRateCurrency(this.form.id, this.deletePassword);
        if (result) {
          $("#DeleteCurrency").modal("hide");
          this.getExchangeRate();
          this.form = {id: null, name: "", code: ""};
          this.deletePassword = "";

          Swal.fire({
            icon: "success",
            title: "Currency deleted successfully!",
            confirmButtonColor: "#dc3545",
            timer: 2000
          });
        }
      } catch (error) {
        if (error.response && error.response.status === 422) {
          this.errors = error.response.data.errors;
        } else {
          Swal.fire({
            icon: "error",
            title: "Something went wrong",
            text: error.message || "Please try again later",
            timer: 2000
          });
        }
      }
    }
  },
  async created() {
    this.searchDebounced = _.debounce(this.applyFilters, 500);
    await this.getExchangeRate();
  },
  watch: {
    "form.name"(val) {
      if (!val) this.errors.currency_name = null;
    },
    "form.code"(val) {
      if (!val) this.errors.currency_code = null;
    },
    deletePassword(val) {
      if (!val) this.errors.password = null;
    },
    "searchParams.search"() {
      this.searchDebounced();
    }
  }
}
</script>

<template>
  <div class="row">
    <div class="col-sm-9">
      <h3 class="text-left">Exchange Currencies Settings</h3>
    </div>

    <div class="col-sm-3 text-right">
      <button class="e-btn e-btn-green e-text-white pr-3 mt-2"
              @click="openCreateModal">
        <font-awesome-icon icon="plus-square" style="width: 25px"/>
        <small class="font-weight-bold">NEW CURRENCY</small>
      </button>
    </div>

    <div class="col-12 pl-0 text-center col-lg-12">
      <div class="row no-gutters align-items-center mb-2">
        <nav aria-label="..." class="col">
          <ul class="pagination text-smallest mb-0">
            <li class="page-item" :class="{ disabled: pagination.currentPage === 1 }">
              <button class="page-link" @click="setPage(1)">First</button>
            </li>
            <li v-for="page in paginationPages" :key="page"
                class="page-item"
                :class="{ disabled: page==='...', active: page === pagination.currentPage }">
              <button class="page-link" @click="setPage(page)">{{ page }}</button>
            </li>
            <li class="page-item" :class="{ disabled: pagination.currentPage === pagination.lastPage }">
              <button class="page-link" @click="setPage(pagination.lastPage)">Last</button>
            </li>
          </ul>
        </nav>
        <div class="col-4 ml-auto">
          <form @submit.prevent>
            <input type="text"
                   class="form-control form-control-sm"
                   v-model="searchParams.search"
                   placeholder="Search Currency"
            >
          </form>
        </div>
      </div>

      <table class="table table-sm table-bordered small mt-1">
        <thead>
        <tr>
          <th style="width: 2%">#</th>
          <th style="width: 20%">CURRENCY</th>
          <th style="width: 20%">CODE</th>
          <th style="width: 2%">ACTION</th>
        </tr>
        </thead>
        <tbody>
        <tr v-if="loading">
          <td colspan="100%">
            <loading></loading>
          </td>
        </tr>

        <tr v-else-if="list.length === 0">
          <td colspan="100%" class="text-center text-muted font-weight-bold">
            No currency found
          </td>
        </tr>

        <template v-else>
          <tr v-for="(data, index) in list" :key="data.id">
            <td class="align-middle">{{ index + 1 + (pagination.currentPage - 1) * searchParams.perPage }}</td>
            <td class="align-middle">{{ data.currency_name }}</td>
            <td class="align-middle">{{ data.currency_code }}</td>
            <td class="text-white">
              <div class="btn-group dropleft">
                <button class="mr-2 btn btn-sm btn-secondary force-white-all"
                        data-toggle="dropdown">
                  <font-awesome-icon icon="cogs"/>
                </button>
                <div class="dropdown-menu">
                  <button class="dropdown-item text-secondary font-weight-bolder"
                          @click="openUpdateModal(data)">
                    <font-awesome-icon icon="pen"/> Update
                  </button>
                  <button class="dropdown-item text-secondary font-weight-bolder text-danger"
                          @click="openDeleteModal(data)">
                    <font-awesome-icon icon="trash" class="force-danger-all"/> Delete
                  </button>
                </div>
              </div>
            </td>
          </tr>
        </template>
        </tbody>
      </table>
    </div>

    <form @submit.prevent="createCurrency">
      <div class="modal fade" id="CreateCurrency" tabindex="-1">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header text-white">
              <h5 class="modal-title font-weight-bold">Create Currency</h5>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label>Name</label>
                <input v-model="form.name" type="text" class="form-control" placeholder="Currency Name" required/>
                <small v-if="errors.currency_name" class="text-danger">
                  {{ errors.currency_name[0] }}
                </small>
              </div>
              <div class="form-group">
                <label>Code</label>
                <input v-model="form.code" type="text" class="form-control" placeholder="Currency Code" required/>
                <small v-if="errors.currency_code" class="text-danger">
                  {{ errors.currency_code[0] }}
                </small>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
              <button type="submit" class="btn btn-success" :disabled="!isCreateReady">Create</button>
            </div>
          </div>
        </div>
      </div>
    </form>

    <form @submit.prevent="updateCurrency">
      <div class="modal fade" id="UpdateCurrency" tabindex="-1">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header text-white">
              <h5 class="modal-title font-weight-bold">Update Currency</h5>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label>Name</label>
                <input v-model="form.name" type="text" class="form-control" placeholder="Currency Name" required/>
                <small v-if="errors.currency_name" class="text-danger">
                  {{ errors.currency_name[0] }}
                </small>
              </div>
              <div class="form-group">
                <label>Code</label>
                <input v-model="form.code" type="text" class="form-control" placeholder="Currency Name" required/>
                <small v-if="errors.currency_code" class="text-danger">
                  {{ errors.currency_code[0] }}
                </small>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
              <button type="submit" class="btn btn-primary" :disabled="!isFormChanged">Update</button>
            </div>
          </div>
        </div>
      </div>
    </form>

    <form @submit.prevent="deleteCurrency">
      <div class="modal fade" id="DeleteCurrency" tabindex="-1">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header text-white">
              <h5 class="modal-title font-weight-bold">Delete Currency</h5>
            </div>
            <div class="modal-body">
              <p>Enter your password to confirm deletion of <strong>{{ form.name }}</strong> ({{ form.code }})</p>
              <input type="password" v-model="deletePassword" class="form-control" placeholder="Password" required/>
              <small v-if="errors.password" class="text-danger">
                {{ errors.password[0] }}
              </small>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
              <button type="submit" class="btn btn-danger" :disabled="!isDeleteReady">Delete</button>
            </div>
          </div>
        </div>
      </div>
    </form>

  </div>
</template>
